module.exports = __webpack_public_path__ + "static/Gotham-Light-a2a8c70557da0c4d4db489d9f66e14b3.woff2";